import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFormUserDetails } from '../../../redux/actions/s2txtActions'

const UserForm = ({ index }) => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [FT, setFT] = useState(false)
    const [M, setM] = useState(false)
    const [NC, setNC] = useState(false)
    const [submit, setSubmit] = useState(true)
    const attendanceReport = useSelector(state => state.attendanceReport)
    const { submitState } = attendanceReport
    const dispatch = useDispatch()

    useEffect(() => {
        if (!submitState) {
            setSubmit(true)
        }
    }, [submitState])

    useEffect(() => {
        if (submitState) {
            if (submit) {
                const obj = {
                    name: name,
                    email,
                    newConvert: NC? 1 : 0,
                    member: M? 1 : 0,
                    firstTimer: FT? 1 : 0,
                    nc: NC? 'X' : '-',
                    m: M? 'X' : '-',
                    ft: FT? 'X' : '-',
                    check: !NC && !M && !FT? false : true
                }
                dispatch(setFormUserDetails(obj))
                setSubmit(false)
            }
        }

        
    }, [FT, M, NC, dispatch, email, name, submit, submitState])

    return (
        <div className='f-e-c'>
            <div className="form-element">
                <label className='label' htmlFor={`stream-name${index}`}>Name </label>
                <input required className='field' type="text" name={`stream-name${index}`} id={`stream-name${index}`} value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            <div className="form-element">
                <label className='label' htmlFor={`stream-email${index}`}>Email </label>
                <input required className='field' type="text" name={`stream-email${index}`} id={`stream-email${index}`} value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div className="form-element stream-user-status">
                <p>Status: </p>
                <label htmlFor={`stream-ft${index}`}>
                    <input className='field' type="checkbox" name={`stream-ft${index}`} id={`stream-ft${index}`} 
                    value='FT' onChange={(e) => setFT(!FT)} /> <span>FT</span> 
                </label>

                <label htmlFor={`stream-nc${index}`}>
                    <input className='field' type="checkbox" name={`stream-nc${index}`} id={`stream-nc${index}`} 
                    value='NC' onChange={(e) => setNC(!NC)} /> <span>NC</span>
                </label>

                <label htmlFor={`stream-m${index}`}>
                    <input className='field' type="checkbox" name={`stream-m${index}`} id={`stream-m${index}`} 
                    value='M' onChange={(e) => setM(!M)} /> <span>M</span>
                </label>
            </div>
        </div> 
    )
}

export default UserForm